import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = { class: "question-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_image = _resolveComponent("dynamic-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.question.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_dynamic_image, {
            image: _ctx.question.image
          }, null, 8, ["image"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.question.text), 1)
  ], 64))
}